//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Shizgal_Rosa',
  data() {
    return {
      form: {
        weight: '',
        height:'',
        age:''
      },
      hasScore: false,
      disabled: false,
      num: '',
      num1: '',
      dataList:[
        { value: "1", name: "男" },
        { value: "0", name: "女" },
      ]
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        self.hasScore = true;
        self.num = (88.362+13.397*form.weight + 4.799*form.height - 5.677*form.age).toFixed(3)
        self.num1 = (447.593+9.247*form.weight+3.098*form.height-4.330*form.age).toFixed(3)
        return String(self.num,self.num1)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Shizgal_Rosa.vue